import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
    EMPLOYEE_AUTH_SERVICE_IMPL,
    IEmployeeAuthService,
} from 'pm-src/services/employee-auth/i-employee-auth.service';
import { ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AUTH_SERVICE_IMPL, IAuthenticationService } from 'shared';

@Component({
    selector: 'app-logout',
    templateUrl: './logout.component.html',
    styleUrls: ['./logout.component.scss'],
})
export class LogoutComponent implements OnInit {
    private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);

    constructor(
        @Inject(AUTH_SERVICE_IMPL) public _authService: IAuthenticationService,
        @Inject(EMPLOYEE_AUTH_SERVICE_IMPL)
        private _employeeAuthService: IEmployeeAuthService,
        private _router: Router
    ) {}

    ngOnInit(): void {}

    ionViewWillEnter(): void {
        this.logout();
    }

    logout(): void {
        this._employeeAuthService.hasActiveEmployee()
            ? this.logoutFromEmployee()
            : this.logoutFromUser();
    }

    private logoutFromEmployee(): void {
        this._employeeAuthService
            .logout()
            .pipe(takeUntil(this.destroyed$))
            .subscribe(() => this._router.navigate(['/employeelogin']));
    }

    private logoutFromUser(): void {
        this._authService
            .logout()
            .pipe(takeUntil(this.destroyed$))
            .subscribe(() => {
                this._router.navigate(['/login']);
            });
    }

    ngOnDestroy() {
        this.destroyed$.next(true);
        this.destroyed$.complete();
    }
}
